/**
 * Application configuration - reads from runtime config (window.__APP_CONFIG__)
 * or falls back to build-time environment variables (import.meta.env).
 *
 * Runtime config is injected by entrypoint.sh via config.js for Docker deployments.
 */
const runtimeConfig: AppConfig = window.__APP_CONFIG__ ?? {};

export const config = {
  authority: runtimeConfig.VITE_AUTHORITY ?? import.meta.env.VITE_AUTHORITY ?? '',
  clientId: runtimeConfig.VITE_CLIENT_ID ?? import.meta.env.VITE_CLIENT_ID ?? '',
  apiUrl: runtimeConfig.VITE_API_URL ?? import.meta.env.VITE_API_URL ?? '',
} as const;
